// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// ## Customer Create
/**
 *
 * @param {{ name: string, surname: string, phoneNo: string, email: string, regionId: string, image: File, workStartTime: number, workEndTime: number  }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Create = async (form) => {
  const [name = "", surname = ""] = form.fullname.split(" ");
  const data = new FormData();

  data.append("name", name || "");
  data.append("surname", surname || "");
  data.append(`phoneNo`, form.phoneNo);
  data.append(`email`, form.email);
  data.append(`regionId`, form.regionId);
  data.append(`image`, form.image);
  data.append(`workStartTime`, form.workStartTime);
  data.append(`workEndTime`, form.workEndTime);

  const response = await $api.post(Endpoints.Employee.Create(), data);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Update
/**
 *
 * @param {{ name: string, surname: string, phoneNo: string, email: string, regionId: string, image: File, workStartTime: number, workEndTime: number  }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const fd = new FormData();

  if (form.fullname) {
    const [name = "", surname = ""] = form.fullname.split(" ");
    fd.append("name", name || "");
    fd.append("surname", surname || "");
  }
  if (form.phoneNo) fd.append("phoneNo", form.phoneNo || "");
  if (form.email) fd.append("email", form.email || "");
  if (form.regionId) fd.append("regionId", form.regionId || "");
  if (form.image) fd.append("image", form.image || "");
  if (form.workStartTime) fd.append("workStartTime", form.workStartTime || "");
  if (form.workFinishTime)
    fd.append("workFinishTime", form.workFinishTime || "");
  if (form.salesTarget?.count || form.salesTarget?.count === 0)
    fd.append("salesTarget.count", form.salesTarget.count || 0);
  if (form.salesTarget?.bonusAmount || form.salesTarget?.bonusAmount === 0)
    fd.append("salesTarget.bonusAmount", form.salesTarget.bonusAmount || 0);
  if (form.varietyTarget?.count || form.varietyTarget?.count === 0)
    fd.append("varietyTarget.count", form.varietyTarget.count || 0);
  if (form.varietyTarget?.bonusAmount || form.varietyTarget?.bonusAmount === 0)
    fd.append("varietyTarget.bonusAmount", form.varietyTarget.bonusAmount || 0);
  if (form.coefficient) fd.append("coefficient", form.coefficient || 1);
  if (form.bonusAmount) fd.append("bonusAmount", form.bonusAmount || 0);
  if (form.isActive === false || form.isActive === true)
    fd.append("isActive", form.isActive || false);

  const response = await $api.put(Endpoints.Employee.Update(option), fd);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  Update,
  Create,
};
